import { useEffect, useState } from "react";

import {
  LabOrderData,
  getOpenLabOrder,
} from "@modules/documents/getOpenLabOrder";

import { useAuthCredentials } from "./useAuthCredentials";
import { usePatient } from "./usePatient";

/*
 * React hook to fetch open lab orders for a patient
 * */
export const useOpenLabOrder = (): LabOrderData | null | undefined => {
  const patient = usePatient();
  const { accessToken } = useAuthCredentials();
  const [labOrder, setLabOrder] = useState<LabOrderData | null | undefined>(
    undefined
  );

  useEffect(() => {
    if (!patient || !accessToken) return;
    getOpenLabOrder(patient.user_id, accessToken)
      .then((response) => {
        console.log("Lab order response:", response.data);
        setLabOrder(response.data);
      })
      .catch((error) => {
        console.error("Error fetching lab order:", error);
        setLabOrder(null);
      });
  }, [patient, accessToken]);

  return labOrder;
};
